// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6366 ? "afabe961" : chunkId) + "." + {"5836":"d8120af4019b8730","6366":"68ec7a9474ba4292"}[chunkId] + ".js";
};